import type {
  StoredUserSubscriptionTier,
  UserSubscriptionBillingInterval,
  UserSubscriptionStatus,
  UserSubscriptionTier,
} from "./types/userDashboard"

/**
 * Narrows a stored tier to the tiers still on offer. Base (TIER_10) was
 * withdrawn and kept none of its own pricing or labels, so the rows that still
 * carry it are read as Plus.
 */
export function toOfferedTier(
  tier: StoredUserSubscriptionTier,
): UserSubscriptionTier {
  return tier === "TIER_10" ? "TIER_20" : tier
}

export function userSubscriptionTierToPlan(
  tier: UserSubscriptionTier,
): "Pro" | "Enterprise" {
  switch (tier) {
    case "TIER_20":
      return "Pro"
    case "TIER_30":
      return "Enterprise"
  }
}
export const getIntervalText = (interval: UserSubscriptionBillingInterval) =>
  interval === "YEAR" ? "annual" : "monthly"

/** Should match the query in `findCurrentSubscription` method */
export function isSubscriptionActive(subscription: {
  status: UserSubscriptionStatus
  currentPeriodEnd?: Date | string | null
  endedAt?: Date | string | null
}): boolean {
  const { status, currentPeriodEnd, endedAt } = subscription

  const currentPeriodEndDate = currentPeriodEnd
    ? new Date(currentPeriodEnd)
    : null
  const endedAtDate = endedAt ? new Date(endedAt) : null

  switch (status) {
    case "PAUSED":
      return false
    case "ACTIVE":
      return true
    case "CANCELLED": {
      if (!currentPeriodEndDate) return false

      return (
        currentPeriodEndDate >= new Date() &&
        (!endedAtDate || endedAtDate >= new Date())
      )
    }
  }
}
